/**
 * Geldbeträge werden im gesamten System als ganzzahlige Cent-Werte gehalten.
 * Niemals Fließkomma für Beträge verwenden.
 */

export type Cents = number;

const EUR = new Intl.NumberFormat("de-AT", {
  style: "currency",
  currency: "EUR",
});

/** Cent → "€ 1.234,56" (de-AT) */
export function formatMoney(cents: Cents): string {
  return EUR.format(cents / 100);
}

/** Freitext-Eingabe ("1.234,56", "1234.5", "€ 90") → Cent */
export function centsFromInput(value: string): Cents {
  const cleaned = value
    .replace(/[^\d,.-]/g, "")
    .replace(/\.(?=\d{3}\b)/g, "")
    .replace(",", ".");
  const n = Number.parseFloat(cleaned || "0");
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}

/** Cent → "1234.56" (für <input>-Defaultwerte) */
export function inputFromCents(cents: Cents): string {
  return (cents / 100).toFixed(2);
}

/** Cent → "1234,56" (Komma statt Punkt — für editierbare Beträge, s. MoneyInput). */
export function editableAmountFromCents(cents: Cents): string {
  return (cents / 100).toFixed(2).replace(".", ",");
}

/** Kaufmännisch runden auf ganze Cent. */
export function roundCents(value: number): Cents {
  return Math.round(value);
}

/** Prozentsatz (z. B. 20 für 20 %) auf einen Netto-Cent-Betrag anwenden. */
export function taxFromNet(netCents: Cents, ratePercent: number): Cents {
  return Math.round((netCents * ratePercent) / 100);
}

export function sumCents(values: readonly Cents[]): Cents {
  return values.reduce((acc, v) => acc + v, 0);
}
